import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiConfig } from '../Config/api.config';
@Injectable({
  providedIn: 'root'
})
export class ContactService {

  constructor(private http: HttpClient) {}

  postContact(userSession: string, name: string, number: string, displayNumber: string, requestType: string): Observable<any> {
    const headers = new HttpHeaders({
      'X-Api-Key': ApiConfig.apiKey,
      'Authorization': `Bearer ${userSession}`
    });

    const request = {
      name,
      number,
      displayNumber,
      requestType
    };
    return this.http.post(
      `${ApiConfig.baseUrl}/contact/add-contact`,
      request,
      {
        headers
      }
    );
  }
}